import Component from '@glimmer/component';

interface ApplicantCommonInfosArgs {
  isProfile?: boolean;
  disabled?: boolean;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class ApplicantCommonInfos extends Component<ApplicantCommonInfosArgs> {
  get isDisabledWhenProfile() {
    if (this.args.isProfile) return true;
    return this.args.disabled;
  }
}
